import { useQuery } from "@tanstack/react-query";
import { visitsAPI } from "../../services/api";

/**
 * The org's configurable visit outcomes (Settings → Visits), cached.
 * outcomeInfo(visit) resolves the label/colour for a visit's outcome, falling
 * back to the label stored on the visit when the outcome was later removed.
 */
const useVisitOutcomes = () => {
  const { data: outcomes = [] } = useQuery({
    queryKey: ["visit-outcomes"],
    queryFn: async () => (await visitsAPI.getOutcomes()).data?.data || [],
    staleTime: 5 * 60000,
  });

  const outcomeInfo = (visit) => {
    if (!visit?.outcome) return null;
    const def = outcomes.find((o) => o.key === visit.outcome);
    return {
      label: def?.label || visit.outcomeLabel || visit.outcome,
      color: def?.color || "#6B7280",
    };
  };

  return { outcomes, outcomeInfo };
};

export default useVisitOutcomes;
